(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngResource', 'ngRoute', 'ui.bootstrap', 'toastr', 'ng.deviceDetector', 'angularUtils.directives.dirPagination', 'ui.select', 'ngBootstrap', 'chart.js', 'angularValidator']);

})();

(function() {
  'use strict';

  angular
      .module('quantumCorpDashUi')
      .service('userAuth', userAuth);

  /** @ngInject */
  function userAuth($location, $log, $rootScope) {
  //function userAuth($location, $log, $rootScope, $cookies) {

    var user = {};

    user.data = {}

    user.debugMode = function() {
      user.data.debugMode = true;
    }

    user.logout = function() {
      user.data = {}
      $rootScope.$emit('loggedOut', true)
      //$cookies.remove('user')
      $location.path("/login");
    }

    return user

  }

})();

(function() {
  'use strict';

  angular
      .module('quantumCorpDashUi')
      .service('quantumApi', quantumApi);

  /** @ngInject */
  function quantumApi($resource) {

    var api = {};

    var baseUrl = '/api/v1'
    // console.log("This linter error is here to remind me to switch the Base URL in the API service")
    // var baseUrl = 'http://qadashboard.jnlquantum.com/api/v1' // DEV ONLY

    api.login = $resource(baseUrl + '/login',{},
    {
      'save':    {method:'POST'}
    })

    api.site = $resource(baseUrl + '/site/:id',{},
    {
      'update':    {method:'PUT'}
    })

    api.siteGroup = $resource(baseUrl + '/site-group/:id',{},
    {
      'update':    {method:'PUT'}
    })

    api.siteContact = $resource(baseUrl + '/site-contact/:id',{},
    {
      'update':    {method:'PUT'}
    })

    api.alarm = $resource(baseUrl + '/alarm/:id',{},
    {
      'update':    {method:'PUT'}
    })

    api.alarmOverview = $resource(baseUrl + '/alarm/corporate-overview/:id',{},
    {
      'update':    {method:'PUT'}
    })

    api.area = $resource(baseUrl + '/area/:id',{},
    {
      'update':    {method:'PUT'}
    })

    api.eventMessage = $resource(baseUrl + '/event-message/:id',{},
    {
      'update':    {method:'PUT'}
    })

    api.staff = $resource(baseUrl + '/staff/:id',{},
    {
      'update':    {method:'PUT'},
      'usedCodes': {
        method:'get',
        url:baseUrl + '/staff/used-codes'
      }
    })

    api.staffType = $resource(baseUrl + '/staff-type/:id',{},
    {
      'update':    {method:'PUT'}
    })

    return api

  }

})();

(function() {
  'use strict';

  angular
      .module('quantumCorpDashUi')
      .service('navItems', navItems);

  /** @ngInject */
  function navItems(userAuth) {

    // So, this exists to filter the menus based on access level and license

    var navItems = {};

    function init() {
      navItems.leftNavigationItems = []
      // Right Nav Does not Support Flyouts, Supports FA Icons, Functions
      navItems.rightNavigationItems = []
    }

    navItems.rebuild = function() {
      init()
      // Dashboard Access
      if (true) {
        navItems.leftNavigationItems.push(
          {"name":"Dashboard", "link":"/"}
          //{"name":"Map", "link":"map"} // TODO: Map returning soon...
        )
      }

      // Site
      if (userAuth.data.corporate) {
        navItems.leftNavigationItems.push(
            {"name":"Sites", "link":"#", "subNav":[
              {"name":"Site Details", "link":"site"},
              {"name":"Site Groups", "link":"site-group"}
            ]
          }
        )
      }

      // Staff
      if (userAuth.data.corporate) {
        navItems.leftNavigationItems.push(
            {"name":"Staff", "link":"#", "subNav":[
              {"name":"Staff Management", "link":"staff"}
            ]
          }
        )
      }

      // Reports
      if (true) {
        navItems.leftNavigationItems.push(
            {"name":"Reports", "link":"#", "subNav":[
              {"name":"Site Overview Report", "link":"report-site-overview"}
            ]
          }
        )
      }

      // Right Menu Items
      // if (true) {
      //   navItems.rightNavigationItems.push(
      //     {"icon":"fa fa-gear", "link":"map", "subNav":[
      //       {"name":"System Setup", "link":"admin-system-setup"}
      //     ]}
      //   )
      // }

      // Normal User Menu
      navItems.rightNavigationItems.push(
        {"name":userAuth.data.full_name, "link":"#", "subNav":[
          {"name":"Logout", "link":"", "function":function(){
            userAuth.logout()
          }}
        ]}
      )

    }

    // Run on page load - build navigation if cookie set and no login function runs
    if (userAuth.data.id) {
      navItems.rebuild()
    }

    return navItems

  }

})();

(function() {
 'use strict';

 angular
   .module('quantumCorpDashUi')
   .factory('httpRequestInterceptor', function(userAuth) {

   return {
      request: function (config) {
      config.headers['Auth-Token'] = userAuth.data.token;
      return config;
      }
    };
   })

})();

(function() {
  'use strict';

  angular
      .module('quantumCorpDashUi')
      .service('dateKeeper', dateKeeper);

  /** @ngInject */
  function dateKeeper(moment) {

    var date = {};

    // Timepicker Defaults
    date.dateSelected = {
      "startDate": moment(),
      "endDate": moment()
    }

    return date

  }

})();

(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .directive('quantumNavbar', quantumNavbar);

  /** @ngInject */
  function quantumNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/directiveNavbar/navbar.html',
      scope: {},
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController($log, userAuth, navItems) {
      var vm = this;
      vm.navItems = navItems
      vm.isCollapsed = false;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .directive('ignoreMouseNumber', ignoreMouseNumber);

  /** @ngInject */
  function ignoreMouseNumber() {

    return {
      restrict: 'A',
      link: function (scope, element) {
        element.bind('mousewheel', function (event) {
          event.preventDefault();
        });
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .controller('StaffController', StaffController);


  /** @ngInject */
  function StaffController($log, toastr, quantumApi, $q) {
    var vm = this;
    var keycardEnrolled = []
    var keypadEnrolled = []

    vm.selectedStaff = null
    // Sometimes generators aren't the best idea
    vm.previousStaffs = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false

    vm.staffTypes = quantumApi.staffType.query()
    vm.siteGroups = quantumApi.siteGroup.query()

    vm.findById = function(id, array) {
      var objectToReturn
      angular.forEach(array, function(value) {
        if (value.id == id) {
          objectToReturn = value
        }
      })
      return objectToReturn
    }

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevStaff, nextStaff) {
      if (event.which == 38 && prevStaff) {
        event.preventDefault()
        vm.selectedStaff = prevStaff
      } else if (event.which == 40 && nextStaff) {
        event.preventDefault()
        vm.selectedStaff = nextStaff
      }
    }

    quantumApi.staff.usedCodes(function(data){
      keycardEnrolled = data.used_wiegand
      keypadEnrolled = data.used_keypad_codes
    })

    vm.getStaffs = function() {
      vm.staffs = []
      quantumApi.staff.query(function(data){
        angular.forEach(data, function(value) {
          if(value.active) {
            vm.staffs.push(value)
          }
        })
        vm.previousStaffs = angular.copy(vm.staffs)
      })
      vm.selectedStaff = null
    }

    vm.getStaffs()

    vm.addStaff = function() {
      vm.staffs.push({
        "active": true,
        "auto_logout": 0,
        "email": null,
        "first_name": null,
        "id": null,
        "keycard": null,
        "keypad": null,
        "last_name": null,
        "user_name": null,
        "password": null,
        "site_group": [],
        "staff_type": 1,
        "transaction_id": null
      })
      vm.selectedStaff = vm.staffs[vm.staffs.length - 1]
    }

    vm.removeStaff = function(index, staff) {
        if (angular.equals(staff, vm.selectedStaff)) {
          vm.selectedStaff = null
        }
        if (staff.id && staff.id != 1) {
          staff.deleted = true
        } else if (!staff.id) {
          vm.staffs.splice(index,1)
        }

    }

    vm.staffsValid = function(){
      var val = true
      angular.forEach(vm.staffs, function(staff){
        if (!vm.staffValid(staff)) {
          val = false
        }
      })
      return val
    }

    vm.staffValid = function(staff) {
      if (staff.staff_type == 1) {
        if (!staff.id) {
          return staff.first_name && staff.last_name && staff.user_name && staff.password && (staff.site_group.length > 0)
        } else {
          return staff.first_name && staff.last_name && staff.user_name && staff.site_group.length
        }
      } else if (staff.staff_type == 2) {
        return staff.first_name && staff.last_name && (staff.site_group.length > 0) && (staff.keycard || staff.keypad) && vm.validateKeycard(staff.keycard, staff) && vm.validateKeypad(staff.keypad, staff)
      } else if (staff.staff_type == 3) {
        if (!staff.id) {
          return staff.first_name && staff.last_name && staff.user_name && staff.password && (staff.site_group.length > 0) && (staff.keycard || staff.keypad) && vm.validateKeycard(staff.keycard, staff) && vm.validateKeypad(staff.keypad, staff)
        } else {
          return staff.first_name && staff.last_name && staff.user_name && staff.site_group.length && (staff.keycard || staff.keypad) && vm.validateKeycard(staff.keycard, staff) && vm.validateKeypad(staff.keypad, staff)
        }
      }
    }

    vm.validateKeycard = function(keycard, selectedStaff) {
      if (!keycard) {
        if (selectedStaff) {
          if (selectedStaff.keycard || selectedStaff.keypad) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else if (keycardEnrolled.indexOf(keycard) != -1) {
        if (selectedStaff.id) {
          if (vm.findById(selectedStaff.id, vm.previousStaffs).keycard == keycard) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else if (keycard < 10000 || keycard > 65535) {
        return false
      }
      else {
        return true
      }
    }

    vm.validateKeycardMsg = function(keycard) {
      if (!keycard) {
        return "Keycard Number or Keypad Code Required"
      } else if (keycardEnrolled.indexOf(keycard) != -1) {
        return "Keycard Already Enrolled"
      } else if (!keycard < 10000 || !keycard > 65535) {
        return "Keycard Must be Between 10000 and 65534"
      }
      return true
    }

    vm.validateKeypad = function(keypad, selectedStaff) {
      if (!keypad) {
        if (selectedStaff) {
          if (selectedStaff.keycard || selectedStaff.keypad) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else if (keypadEnrolled.indexOf(keypad) != -1) {
        if (selectedStaff.id) {
          if (vm.findById(selectedStaff.id, vm.previousStaffs).keypad == keypad) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else if (keypad < 1000 || keypad > 9999) {
        return false
      }
      else {
        return true
      }
    }

    vm.validateKeypadMsg = function(keypad) {
      if (!keypad) {
        return "Keycard Number or Keypad Code Required"
      } else if (keypadEnrolled.indexOf(keypad) != -1) {
        return "Keypad Code Already Enrolled"
      } else if (!keypad < 1000 || !keypad > 9999) {
        return "Keypad Code Must be Between 1000 and 9999"
      }
    }

    vm.saveStaffs = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.staffs, function(staff, key) {
        if (staff.id && !staff.deleted) {
          if (!angular.equals(staff, vm.previousStaffs[key])) {
            promises.push(quantumApi.staff.update({id:staff.id},staff).$promise)
          }
        } else if (staff.deleted) {
          promises.push(quantumApi.staff.delete({id:staff.id},staff).$promise)
        } else {
          promises.push(quantumApi.staff.save(staff).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getStaffs()
        toastr.success("Staffs Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Staffs", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .controller('SiteGroupController', SiteGroupController);

  /** @ngInject */
  function SiteGroupController($log, toastr, quantumApi, $q) {
    var vm = this;

    vm.selectedGroup = null
    vm.previousGroups = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.ladda = false

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.keypress = function(event, prevGroup, nextGroup) {
      if (event.which == 38 && prevGroup) {
        event.preventDefault()
        vm.selectedGroup = prevGroup
      } else if (event.which == 40 && nextGroup) {
        event.preventDefault()
        vm.selectedGroup = nextGroup
      }
    }

    vm.loadGroup = function(siteGroup) {
      vm.selectedGroup = siteGroup
      vm.selectedGroup.renderedSites = []
      quantumApi.siteGroup.get({id:siteGroup.id}).$promise
      .then(function(data){
        angular.forEach(data.sites_in_group, function(value) {
          quantumApi.site.get({id:value}).$promise
          .then(function(site){
            vm.selectedGroup.renderedSites.push(site)
          })
        })
      })

    }

    vm.getGroups = function() {
      vm.groups = quantumApi.siteGroup.query(function(data){
        vm.previousGroups = angular.copy(data)
      })
      vm.selectedGroup = null
    }

    vm.getGroups()

    vm.addGroup = function() {
      vm.groups.push({
        id:null,
        name:"New group",
        checkin_staff:[]
      })
      vm.selectedGroup = vm.groups[vm.groups.length - 1]
    }

    vm.removeGroup = function(index, group) {
        if (angular.equals(group, vm.selectedGroup)) {
          vm.selectedGroup = null
        }
        if (group.id && group.id != 1) {
          group.deleted = true
        } else if (!group.id) {
          vm.groups.splice(index,1)
        }

    }

    vm.groupsValid = function(){
      var val = true
      angular.forEach(vm.groups, function(group){
        if (!group.name) {
          val = false
        }
      })
      return val
    }

    vm.groupValid = function(group) {
      return group.name
    }


    vm.saveGroups = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.groups, function(group, key) {
        if (group.id && !group.deleted) {
          if (!angular.equals(group, vm.previousGroups[key])) {
            promises.push(quantumApi.siteGroup.update({id:group.id},group).$promise)
          }
        } else if (group.deleted) {
          promises.push(quantumApi.siteGroup.delete({id:group.id},group).$promise)
        } else {
          promises.push(quantumApi.siteGroup.save(group).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getGroups()
        toastr.success("Groups Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Groups", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .controller('ReportSiteOverviewController', ReportSiteOverviewController);

  /** @ngInject */
  function ReportSiteOverviewController(quantumApi, moment, $location, $scope, dateKeeper) {
    var vm = this;

    vm.findById = function(id, array) {
      var objectToReturn
      angular.forEach(array, function(value) {
        if (value.id == id) {
          objectToReturn = value
        }
      })
      return objectToReturn
    }

    vm.findByName = function(name, array) {
      var objectToReturn
      angular.forEach(array, function(value) {
        if (value.name == name) {
          objectToReturn = value
        }
      })
      return objectToReturn
    }

    vm.datepickerOptions = {
      autoApply: true,
      format: 'MMM D, YYYY',
      dateLimit: { days: 30 },
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      opens: 'left',
      drops: 'down'
    }

    // Timepicker Defaults
    vm.date = {
      "startDate": moment(),
      "endDate": moment()
    }

    vm.pieChartClick = function(data) {
      var siteSelected = vm.findByName(vm.alarmBySiteKeys[data[0]._index], vm.sites).id
      $location.path("/report-site-detail/"+siteSelected);
      $scope.$apply()
    }

    vm.siteClick = function(siteName) {
      var siteSelected = vm.findByName(siteName, vm.sites).id
      $location.path("/report-site-detail/"+siteSelected);
      $scope.$apply()
    }

    vm.loadEvents = function() {
      vm.initalLoadComplete = false
      quantumApi.site.query().$promise
      .then(function(data){
        vm.sites = data
      })
      .then(function(){
        vm.alarms = quantumApi.alarmOverview.get({"start_date":moment(vm.date.startDate).format('YYYY_MM_DD'), "end_date":moment(vm.date.endDate).format('YYYY_MM_DD')}).$promise
        .then(function(data){
          dateKeeper.dateSelected.startDate = moment(vm.date.startDate)
          dateKeeper.dateSelected.endDate = moment(vm.date.endDate)
          vm.initalLoadComplete = true
          // Alarm by hours
          vm.initInsights()
          angular.forEach(data.hours, function(value) {
            vm.alarmByHourValuesTemp.push(value.total)
            vm.alarmByHourResponseValuesTemp.push((value.average_duration / value.c / 60).toFixed(0))
          })
          vm.alarmByHourTotals.push(vm.alarmByHourValuesTemp)
          // This was not a good idea "Average of Averages"
          //vm.alarmByHourTotals.push(vm.alarmByHourResponseValuesTemp)

          // Alarms By Site & Statistics
          angular.forEach(data.sites, function(value, key) {
            var siteName = vm.findById(key, vm.sites).name
            // Charts
            vm.alarmBySiteKeys.push(siteName)
            vm.alarmBySiteTotals.push(value.total_alarms)
            vm.responseBySiteTotals.push((value.average_response / 60).toFixed(0))
            // Lists
            vm.sitesByAlarms.push({name:siteName, total_alarms: value.total_alarms})
            vm.sitesByResponse.push({name:siteName, average_response: (value.average_response/60).toFixed(0)})
          })
        })
      })
    }

    vm.chartDatasetOverride = [
      {
        label: "Total Alarms",
        type: 'bar'
      }
    ]

    vm.initInsights = function() {
      // Alarms by Hours
      vm.alarmByHourKeys = ["12AM","1AM","2AM","3AM","4AM","5AM","6AM","7AM","8AM","9AM","10AM","11AM","12PM","1PM","2PM","3PM","4PM","5PM","6PM","7PM","8PM","9PM","10PM","11PM"]
      vm.alarmByHourTotals = []
      vm.alarmByHourValuesTemp = []
      vm.alarmByHourResponseValuesTemp = []
      // Alarms by Site
      vm.alarmBySiteKeys = []
      vm.alarmBySiteTotals = []
      vm.responseBySiteTotals = []

      vm.sitesByAlarms = []
      vm.sitesByResponse = []

    }


  }
})();

(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .controller('SiteController', SiteController);

  /** @ngInject */
  function SiteController($log, toastr, quantumApi, $q, $uibModal, $scope) {
    var vm = this;

    vm.selectedSite = null
    vm.previousSites = []
    vm.searchFilter = ""
    vm.filteredList = null
    vm.contactEdit = false
    vm.ladda = false

    vm.siteGroups = quantumApi.siteGroup.query()

    vm.clearSearch = function() {
      vm.searchFilter = ""
    }

    vm.prettyNull = function(value) {
      if(value) {
        return value
      } else {
        return "Unknown"
      }
    }

    // Modal Setup
    vm.openModal = function(selectedContact){
      vm.selectedContact = quantumApi.siteContact.get({'id':selectedContact.id})
        vm.modalInstance = $uibModal.open({
            templateUrl: 'contactModal.html',
            scope: $scope,
            size: 'md'
        });
    }

    vm.closeModal = function(){
      vm.contactEdit = false
      vm.modalInstance.dismiss();
    };

    vm.addContact = function() {
      vm.contactEdit = true
      vm.selectedContact = {
        "active": true,
        "cell_phone": null,
        "email": null,
        "id": null,
        "name": null,
        "office_phone": null,
        "position": null,
        "site_id": vm.selectedSite.id
      }
        vm.modalInstance = $uibModal.open({
            templateUrl: 'contactModal.html',
            scope: $scope,
            size: 'md'
        });
    }

    vm.editContact = function() {
      vm.contactEdit = true
    }

    vm.removeContact = function(contact) {
      quantumApi.siteContact.delete({id:contact.id}).$promise
      .then(function(){
        var index = vm.selectedSite.site_contact.indexOf(contact.id);
        if (index > -1) {
           vm.selectedSite.site_contact.splice(index, 1);
        }
        vm.loadSiteContacts(vm.selectedSite)
        vm.closeModal()
      })
    }

    vm.saveContact = function(contact) {
      if (contact.id) {
        quantumApi.siteContact.update({id:contact.id}, contact).$promise
        .then(function(){
          vm.contactEdit = false
          vm.loadSiteContacts(vm.selectedSite)
        })
      } else {
        quantumApi.siteContact.save({id:contact.id}, contact).$promise
        .then(function(data){
          vm.contactEdit = false
          vm.selectedSite.site_contact.push(data.id)
          vm.loadSiteContacts(vm.selectedSite)
        })
      }
    }

    vm.keypress = function(event, prevSite, nextSite) {
      if (event.which == 38 && prevSite) {
        event.preventDefault()
        vm.selectedSite = prevSite
      } else if (event.which == 40 && nextSite) {
        event.preventDefault()
        vm.selectedSite = nextSite
      }
    }

    vm.loadSiteContacts = function(site) {
      vm.selectedSite.renderedContacts = []
      angular.forEach(site.site_contact, function(id) {
        quantumApi.siteContact.get({id:id}).$promise
        .then(function(data){
          vm.selectedSite.renderedContacts.push(data)
        })
      })
    }

    vm.selectSite = function(site) {
      vm.selectedSite = site
      vm.loadSiteContacts(site)
    }

    vm.getSites = function() {
      vm.sites = quantumApi.site.query(function(data){
        vm.previousSites = angular.copy(data)
      })
      vm.selectedSite = null
    }

    vm.getSites()

    vm.addSite = function() {
      vm.sites.push({
        id:null,
        name:"New site",
        checkin_staff:[]
      })
      vm.selectedSite = vm.sites[vm.sites.length - 1]
    }

    vm.removeSite = function(index, site) {
        if (angular.equals(site, vm.selectedSite)) {
          vm.selectedSite = null
        }
        if (site.id && site.id != 1) {
          site.deleted = true
        } else if (!site.id) {
          vm.sites.splice(index,1)
        }

    }

    vm.sitesValid = function(){
      var val = true
      angular.forEach(vm.sites, function(site){
        if (!site.name) {
          val = false
        }
      })
      return val
    }

    vm.siteValid = function(site) {
      return site.name
    }


    vm.saveSites = function(){
      vm.ladda = true
      var promises = []
      angular.forEach(vm.sites, function(site, key) {
        if (site.id && !site.deleted) {
          if (!angular.equals(site, vm.previousSites[key])) {
            promises.push(quantumApi.site.update({id:site.id},site).$promise)
          }
        } else if (site.deleted) {
          promises.push(quantumApi.site.delete({id:site.id},site).$promise)
        } else {
          promises.push(quantumApi.site.save(site).$promise)
        }
      })

      $q.all(promises)
      .then(function(){
        vm.getSites()
        toastr.success("Sites Saved Successfully", "Success!")
        vm.ladda = false
      })
      .catch(function(err){
        $log.info(err)
        toastr.warning("Failed to Save Sites", "Error!")
        vm.ladda = false
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .controller('ReportSiteDetailController', ReportSiteDetailController);

  /** @ngInject */
  function ReportSiteDetailController($routeParams, quantumApi, moment, dateKeeper, $scope) {
    var vm = this;

    vm.selectedAreaId = null
    vm.selectedTypeId = null

    vm.findByProperty = function(thing, array, property) {
      var objectToReturn
      angular.forEach(array, function(value) {
        if (value[property] == thing) {
          objectToReturn = value
        }
      })
      return objectToReturn
    }

    vm.datepickerOptions = {
      autoApply: true,
      format: 'MMM D, YYYY',
      dateLimit: { days: 30 },
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      opens: 'left',
      drops: 'down'
    }

    // Timepicker Defaults
    vm.date = dateKeeper.dateSelected

    vm.init = function() {
      // Temp Calculations
      vm.totalAlarms = 0
      vm.averageResponseTemp = 0
      vm.averageResponseTempCounter = 0
      vm.alarms = {}
      vm.alarms.alarmsByHourTemp = {0:0, 1:0, 2:0, 3:0, 4:0, 5:0, 6:0, 7:0, 8:0, 9:0, 10:0, 11:0, 12:0, 13:0, 14:0, 15:0, 16:0, 17:0, 18:0, 19:0, 20:0, 21:0, 22:0, 23:0}
      vm.alarms.responseByHourTemp = {0:{total:0, count:0}, 1:{total:0, count:0}, 2:{total:0, count:0}, 3:{total:0, count:0}, 4:{total:0, count:0}, 5:{total:0, count:0}, 6:{total:0, count:0}, 7:{total:0, count:0}, 8:{total:0, count:0}, 9:{total:0, count:0}, 10:{total:0, count:0}, 11:{total:0, count:0}, 12:{total:0, count:0}, 13:{total:0, count:0}, 14:{total:0, count:0}, 15:{total:0, count:0}, 16:{total:0, count:0}, 17:{total:0, count:0}, 18:{total:0, count:0}, 19:{total:0, count:0}, 20:{total:0, count:0}, 21:{total:0, count:0}, 22:{total:0, count:0}, 23:{total:0, count:0}}
      vm.alarms.alarmsByAreaTemp = {}
      vm.alarms.alarmsByTypeTemp = {}
      // Final Chart Values
      vm.alarms.alarmByHourKeys = ["12AM","1AM","2AM","3AM","4AM","5AM","6AM","7AM","8AM","9AM","10AM","11AM","12PM","1PM","2PM","3PM","4PM","5PM","6PM","7PM","8PM","9PM","10PM","11PM"]
      vm.alarms.alarmByHourValues = []
      vm.alarms.responseByHourValues = []
      vm.alarms.byHourValues = []
      // By Type
      vm.alarms.byTypeKeys = []
      vm.alarms.byTypeValues = []
      // By Area
      vm.alarms.byAreaKeys = []
      vm.alarms.byAreaValues = []
      // Busiest Displays
      vm.mostAlarmsByAreaTempCount = 0
      vm.mostAlarmsByArea = ""
      vm.mostAlarmsByTypeTempCount = 0
      vm.mostAlarmsByType = ""
    }


    vm.loadAlarms = function() {
      var siteID = $routeParams.id
      vm.siteInfo = quantumApi.site.get({id:siteID})
      vm.initalLoadComplete = false
      quantumApi.area.query(function(data){
        vm.areas = []
        angular.forEach(data, function(value) {
          if (value.site_id == siteID) {
            vm.areas.push(value)
          }
        })
      }).$promise
      .then(function(){return quantumApi.eventMessage.query().$promise})
      .then(function(data){
        vm.eventMessages = data
      })
      .then(function(){
        dateKeeper.dateSelected = vm.date
        return quantumApi.alarm.query({site_id:siteID, "start_date":moment(vm.date.startDate).format('YYYY_MM_DD'), "end_date":moment(vm.date.endDate).format('YYYY_MM_DD')}).$promise
      })
      .then(function(data){
        vm.selectedAlarms = data
        vm.recalulateData()
      })
    }

    vm.recalulateData = function() {
      vm.init()
      // Iterate the Hours
      angular.forEach(vm.selectedAlarms, function(hour) {
        // Alarms By Hour
        if(!vm.selectedAreaId && !vm.selectedTypeId) {
          vm.averageResponseTemp = vm.averageResponseTemp + hour.average_duration
          vm.averageResponseTempCounter ++
          vm.totalAlarms = vm.totalAlarms + hour.total_alarms
          vm.alarms.alarmsByHourTemp[hour.hour] = vm.alarms.alarmsByHourTemp[hour.hour] + hour.total_alarms
          // Response by Hour
          vm.alarms.responseByHourTemp[hour.hour].total = vm.alarms.responseByHourTemp[hour.hour].total + hour.average_duration
          vm.alarms.responseByHourTemp[hour.hour].count ++
          // Alarms By Area & Type
          angular.forEach(hour.alarms_by_area, function(value, key) {
            if (!vm.alarms.alarmsByAreaTemp[key]) {
              vm.alarms.alarmsByAreaTemp[key] = value.total
            } else {
              vm.alarms.alarmsByAreaTemp[key] = vm.alarms.alarmsByAreaTemp[key] + value.total
            }
            // By Type
            // Alarms By Type
            angular.forEach(value.types, function(value, key) {
              if (!vm.alarms.alarmsByTypeTemp[key]) {
                vm.alarms.alarmsByTypeTemp[key] = value.total
              } else {
                vm.alarms.alarmsByTypeTemp[key] = vm.alarms.alarmsByTypeTemp[key] + value.total
              }
            })
          })
        } else if (vm.selectedAreaId && !vm.selectedTypeId) {
          angular.forEach(hour.alarms_by_area, function(value, key) {
            if (key == vm.selectedAreaId) {
              vm.averageResponseTemp = vm.averageResponseTemp + value.average_duration
              vm.averageResponseTempCounter ++
              vm.totalAlarms = vm.totalAlarms + value.total
              vm.alarms.alarmsByHourTemp[hour.hour] = vm.alarms.alarmsByHourTemp[hour.hour] + value.total
              vm.alarms.responseByHourTemp[hour.hour].total = parseInt(vm.alarms.responseByHourTemp[hour.hour].total) + parseInt(value.average_duration)
              vm.alarms.responseByHourTemp[hour.hour].count ++
              if (!vm.alarms.alarmsByAreaTemp[key]) {
                vm.alarms.alarmsByAreaTemp[key] = value.total
              } else {
                vm.alarms.alarmsByAreaTemp[key] = vm.alarms.alarmsByAreaTemp[key] + value.total
              }
              angular.forEach(value.types, function(value, key) {
                if (!vm.alarms.alarmsByTypeTemp[key]) {
                  vm.alarms.alarmsByTypeTemp[key] = value.total
                } else {
                  vm.alarms.alarmsByTypeTemp[key] = vm.alarms.alarmsByTypeTemp[key] + value.total
                }
              })
            }
          })
        } else if (!vm.selectedAreaId && vm.selectedTypeId) {
          angular.forEach(hour.alarms_by_area, function(areaValue, areaKey) {
            angular.forEach(areaValue.types, function(typeValue, typeKey) {
              if (vm.selectedTypeId == typeKey) {
                vm.totalAlarms = vm.totalAlarms + typeValue.total
                vm.averageResponseTemp = vm.averageResponseTemp + typeValue.average_duration
                vm.averageResponseTempCounter ++
                vm.alarms.alarmsByHourTemp[hour.hour] = vm.alarms.alarmsByHourTemp[hour.hour] + typeValue.total
                vm.alarms.responseByHourTemp[hour.hour].total = vm.alarms.responseByHourTemp[hour.hour].total + typeValue.average_duration
                vm.alarms.responseByHourTemp[hour.hour].count ++
                if (!vm.alarms.alarmsByAreaTemp[areaKey]) {
                  vm.alarms.alarmsByAreaTemp[areaKey] = typeValue.total
                } else {
                  vm.alarms.alarmsByAreaTemp[areaKey] = vm.alarms.alarmsByAreaTemp[areaKey] + typeValue.total
                }
                if (!vm.alarms.alarmsByTypeTemp[typeKey]) {
                  vm.alarms.alarmsByTypeTemp[typeKey] = typeValue.total
                } else {
                  vm.alarms.alarmsByTypeTemp[typeKey] = vm.alarms.alarmsByTypeTemp[typeKey] + typeValue.total
                }
              }
            })
          })
        } else if (vm.selectedAreaId && vm.selectedTypeId) {
          angular.forEach(hour.alarms_by_area, function(areaValue, areaKey) {
            if (areaKey == vm.selectedAreaId) {
              angular.forEach(areaValue.types, function(typeValue, typeKey) {
                if (vm.selectedTypeId == typeKey) {
                  vm.totalAlarms = vm.totalAlarms + typeValue.total
                  vm.averageResponseTemp = vm.averageResponseTemp + typeValue.average_duration
                  vm.averageResponseTempCounter ++
                  vm.alarms.alarmsByHourTemp[hour.hour] = vm.alarms.alarmsByHourTemp[hour.hour] + typeValue.total
                  vm.alarms.responseByHourTemp[hour.hour].total = vm.alarms.responseByHourTemp[hour.hour].total + typeValue.average_duration
                  vm.alarms.responseByHourTemp[hour.hour].count ++
                  if (!vm.alarms.alarmsByAreaTemp[areaKey]) {
                    vm.alarms.alarmsByAreaTemp[areaKey] = typeValue.total
                  } else {
                    vm.alarms.alarmsByAreaTemp[areaKey] = vm.alarms.alarmsByAreaTemp[areaKey] + typeValue.total
                  }
                  if (!vm.alarms.alarmsByTypeTemp[typeKey]) {
                    vm.alarms.alarmsByTypeTemp[typeKey] = typeValue.total
                  } else {
                    vm.alarms.alarmsByTypeTemp[typeKey] = vm.alarms.alarmsByTypeTemp[typeKey] + typeValue.total
                  }
                }
              })
            }
          })
        }

      })

      // Data Beautification (Formatting for Charts)
      // Bar Chart
      angular.forEach(vm.alarms.alarmsByHourTemp, function(value) {
        vm.alarms.alarmByHourValues.push(value)
      })
      angular.forEach(vm.alarms.responseByHourTemp, function(value) {
        vm.alarms.responseByHourValues.push(value.total ? ((value.total / 60) / value.count).toFixed() : 0)
      })
      vm.alarms.byHourValues = [vm.alarms.alarmByHourValues, vm.alarms.responseByHourValues]
      // By Type
      angular.forEach(vm.alarms.alarmsByTypeTemp, function(value, key) {
        var keyName = vm.findByProperty(key, vm.eventMessages, "event_code").event_text
        vm.alarms.byTypeKeys.push(keyName)
        vm.alarms.byTypeValues.push(value)

        if (value > vm.mostAlarmsByTypeTempCount) {
          vm.mostAlarmsByTypeTempCount = value
          vm.mostAlarmsByType = keyName
        }
      })
      // By Area
      angular.forEach(vm.alarms.alarmsByAreaTemp, function(value, key) {
        var keyName = vm.findByProperty(key, vm.areas, "id").area_name
        vm.alarms.byAreaKeys.push(keyName)
        vm.alarms.byAreaValues.push(value)
        if (value > vm.mostAlarmsByAreaTempCount) {
           vm.mostAlarmsByAreaTempCount = value
           vm.mostAlarmsByArea = keyName
        }
      })
      // Average Response Calculations
      vm.averageResponse = ((vm.averageResponseTemp / vm.averageResponseTempCounter) / 60).toFixed(0)
      vm.initalLoadComplete = true
      $scope.$apply()
    }

    vm.chartDatasetOverride = [
      {
        label: "Total Alarms",
        type: 'bar'
      },
      {
        label: "Average Response Min",
        type: 'line'
      }
    ]

    vm.areaChartClick = function(data) {
      vm.selectedAreaId = vm.findByProperty(vm.alarms.byAreaKeys[data[0]._index], vm.areas ,"area_name").id
      vm.recalulateData()
    }

    vm.typeChartClick = function(data) {
      vm.selectedTypeId = vm.findByProperty(vm.alarms.byTypeKeys[data[0]._index], vm.eventMessages ,"event_text").event_code
      vm.recalulateData()
    }

    vm.clearAreaFilter = function(){
      vm.selectedAreaId = null
      vm.recalulateData()
    }

    vm.clearTypeFilter = function(){
      vm.selectedTypeId = null
      vm.recalulateData()
    }

  }
})();

(function() {
  'use strict';

// NOTE: Hey you, This is important. It's used by the root page. Don't trash it AGAIN...

  angular
    .module('quantumCorpDashUi')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController(userAuth) {
    var vm = this;

    vm.userAuth = userAuth

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($location, userAuth, deviceDetector, $log, quantumApi, $cookies, $rootScope, toastr, navItems) {
    var vm = this;

    vm.deviceDetector = deviceDetector

    // On display of login page, log out any logged in user
    if ($location.path() === "/login") {
      userAuth.logout()
    }

    vm.unsupportedBrowser = deviceDetector.browser == "ie"

    vm.userData = {
      "username": "",
      "password": ""
    }

    vm.login = function(userData) {
      quantumApi.login.save({"username":userData.username, "password":userData.password}).$promise
      .then(function(data) {
        $rootScope.$emit('loggedIn', true) // Starts the system status refresh interval
        userAuth.data = data
        //$cookies.putObject('user', data)
        $location.path('/dashboard')
        navItems.rebuild()
      })
      .catch(function(){
        toastr.warning("Failled to Log In", "Error!")
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .controller('DashboardController', DashboardController);

  /** @ngInject */
  function DashboardController(quantumApi) {
    var vm = this;
    vm.sites = quantumApi.site.query()

  }
})();

(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, userAuth, $rootScope, $location) {

    var redirectCalback = $rootScope.$on( "$routeChangeStart", function() {
      if (!userAuth.data.id) {
        $location.path("/login");
      }
    })

    $rootScope.$on('$destroy', redirectCalback)
  }

})();

(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .config(routeConfig);

  function routeConfig($routeProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'app/dashboard/dashboard.html',
        controller: 'DashboardController',
        controllerAs: 'vm'
      })
      .when('/login', {
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm'
      })
      .when('/site',
        {templateUrl: 'app/site/site.html',
        controller: 'SiteController',
        controllerAs: 'vm'
      })
      .when('/site-group',
        {templateUrl: 'app/site-group/site-group.html',
        controller: 'SiteGroupController',
        controllerAs: 'vm'
      })
      .when('/staff',
        {templateUrl: 'app/staff/staff.html',
        controller: 'StaffController',
        controllerAs: 'vm'
      })
      .when('/report-site-overview',
        {templateUrl: 'app/report-site-overview/report-site-overview.html',
        controller: 'ReportSiteOverviewController',
        controllerAs: 'vm'
      })
      .when('/report-site-detail',
        {templateUrl: 'app/report-site-detail-selector/report-site-detail-selector.html',
        controller: 'ReportSiteDetailSelectorController',
        controllerAs: 'vm'
      })
      .when('/report-site-detail/:id',
        {templateUrl: 'app/report-site-detail/report-site-detail.html',
        controller: 'ReportSiteDetailController',
        controllerAs: 'vm'
      })
      .otherwise({
        redirectTo: '/'
      });
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('quantumCorpDashUi')
    .config(config);

  /** @ngInject */
  function config($logProvider, $locationProvider, toastrConfig, $httpProvider, uiSelectConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Inject the Auth Token for Quantum API Requests
    $httpProvider.interceptors.push('httpRequestInterceptor');

    // Remove the hash
    $locationProvider.html5Mode(true);

    // Select2 Theme for UI-Select
    uiSelectConfig.theme = 'select2';
    uiSelectConfig.appendToBody = true

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
  }

})();

angular.module("quantumCorpDashUi").run(["$templateCache", function($templateCache) {$templateCache.put("app/dashboard/dashboard.html","<div class=col-md-12 style=padding-top:20px><div class=\"input-group search-box\"><input type=text ng-model=vm.searchFilter placeholder=Search class=form-control><div class=input-group-btn><button class=btn type=button ng-click=\"vm.searchFilter = \'\'\"><i class=\"fa fa-times text-muted\"></i></button></div></div></div><div class=\"col-md-4 col-lg-3\" ng-repeat=\"site in vm.sites | filter:vm.searchFilter | orderBy:\'name\'\"><div class=\"box box-color box-bordered\" ng-class=\"{\'green\':(!site.site_general_info.offline_hardware && !site.site_general_info.low_battery && !site.site_general_info.missing_device), \'red\':(site.site_general_info.offline_hardware || site.site_general_info.low_battery || site.site_general_info.missing_device)}\"><div class=box-title><h3><i class=fa ng-class=\"{\'fa-check-circle-o\':(!site.site_general_info.offline_hardware && !site.site_general_info.low_battery && !site.site_general_info.missing_device), \'fa-times-circle-o\':(site.site_general_info.offline_hardware || site.site_general_info.low_battery || site.site_general_info.missing_device)}\"></i>{{site.name}}</h3></div><div class=\"box-content nopadding\"><table class=table><tr><td><h5><i class=fa ng-class=\"{\'fa-check-circle-o\':!site.site_general_info.offline_hardware, \'fa-times-circle-o\':site.site_general_info.offline_hardware, \'text-success\':!site.site_general_info.offline_hardware, \'text-danger\':site.site_general_info.offline_hardware}\"></i> Offline Hardware: {{site.site_general_info.offline_hardware}}</h5></td></tr><tr><td><h5><i class=fa ng-class=\"{\'fa-check-circle-o\':!site.site_general_info.low_battery, \'fa-times-circle-o\':site.site_general_info.low_battery, \'text-success\':!site.site_general_info.low_battery, \'text-danger\':site.site_general_info.low_battery}\"></i> Low Batteries: {{site.site_general_info.low_battery}}</h5></td></tr><tr><td><h5><i class=fa ng-class=\"{\'fa-check-circle-o\':!site.site_general_info.missing_device, \'fa-times-circle-o\':site.site_general_info.missing_device, \'text-success\':!site.site_general_info.missing_device, \'text-danger\':site.site_general_info.missing_device}\"></i> Missing Devices: {{site.site_general_info.missing_device}}</h5></td></tr><tr><td><h5><i class=\"fa fa-check-circle-o text-success\"></i> Weekly Alarms: {{site.total_alarms}}</h5></td></tr><tr><td><h5><i class=\"fa fa-check-circle-o text-success\"></i> Weekly Response: {{(site.average_duration / 60).toFixed(0)}} min.</h5></td></tr></table></div></div></div>");
$templateCache.put("app/login/login.html","<div class=wrapper><h1><a href=#><img src=assets/images/logo-big.png>DASHBOARD</a></h1><div class=login-body style=min-height:275px><div class=\"alert alert-danger\" ng-if=vm.unsupportedBrowser><i class=\"fa fa-warning\"></i> Unsupported Web Browser. <a href=https://www.google.com/chrome/browser/desktop/ >Download Chrome</a></div><h2>SIGN IN</h2><form name=loginform ng-submit=vm.login(vm.userData)><div class=form-group><div class=\"email controls\"><input type=text ng-disabled=vm.unsupportedBrowser placeholder=\"User Name\" class=form-control ng-model=vm.userData.username></div></div><div class=form-group><div class=\"pw controls\"><input ng-disabled=vm.unsupportedBrowser type=password placeholder=Password class=form-control ng-model=vm.userData.password></div></div><div class=submit ng-if=!vm.unsupportedBrowser><input type=submit class=\"btn btn-primary\"></div></form></div><div class=\"alert alert-success\" ng-if=\"vm.deviceDetector.device == \'android\'\"><i class=\"fa fa-download\"></i> <a href=../assets/mobile/quantum_mobile_1_0.apk target=_self>Download Quantum Mobile</a></div></div>");
$templateCache.put("app/report-site-detail/report-site-detail.html","<div class=pull-right><span ng-if=vm.loading><i class=\"fa fa-spin fa-spinner\"></i></span> <span style=\"cursor: pointer; padding: 5px 10px; border: 1px solid #ccc\"><i class=\"fa fa-calendar\"></i> <input ng-change=vm.loadAlarms() type=daterange readonly datepicker-options=vm.datepickerOptions ng-model=vm.date style=\"cursor: pointer; padding: 5px 10px; border: 0px solid #ccc; width:195px\"><b class=caret style=\"margin-left: -10px\"></b></span></div><div class=pull-right style=\"padding-right: 5px\"><button type=button class=btn ng-click=vm.clearFilers() ng-if=\"vm.filters.event.length || vm.filters.name.length || vm.filters.location.length || vm.filters.area.length\">Clear Filters</button><!-- <button type=\"button\" class=\"btn\" ng-if=\"!vm.loading\" ng-csv=\"vm.cleanCsv(vm.filteredEvents)\" filename=\"{{vm.siteName}}_alarm_history_{{vm.date.startDate|date:\'yyyy-MM-dd\'}}_{{vm.date.endDate|date:\'yyyy-MM-dd\'}}.csv\" csv-header=\"vm.csvHeaders\" lazy-load=\"true\">Save CSV</button> --></div><!-- Insights --><!-- Hide Insights if no results --><div class=box><div class=box-title><h3><i class=fa ng-class=\"{ \'fa-lightbulb-o\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=vm.initalLoadComplete>Site Insights: {{vm.siteInfo.name}}</span><span ng-if=!vm.initalLoadComplete>Loading...</span></h3></div><div class=\"box-content nopadding\"><div class=col-md-3><h5>Alarms By Area <button type=button class=\"btn bnt-small pull-right\" ng-click=vm.clearAreaFilter() ng-if=vm.selectedAreaId>Clear Filter</button></h5><canvas id=doughnut class=\"chart chart-doughnut\" chart-click=vm.areaChartClick chart-data=vm.alarms.byAreaValues chart-labels=vm.alarms.byAreaKeys chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas></div><div class=col-md-6><h5>Alarms By Hour</h5><canvas id=chart class=\"chart chart-bar\" chart-data=vm.alarms.byHourValues chart-labels=vm.alarms.alarmByHourKeys chart-dataset-override=vm.chartDatasetOverride chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas></div><div class=col-md-3><h5>Alarms By Type <button type=button class=\"btn bnt-small pull-right\" ng-click=vm.clearTypeFilter() ng-if=vm.selectedTypeId>Clear Filter</button></h5><canvas id=doughnut class=\"chart chart-doughnut\" chart-click=vm.typeChartClick chart-data=vm.alarms.byTypeValues chart-labels=vm.alarms.byTypeKeys chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas></div></div></div><div class=row><div class=col-md-3><div class=\"col-md-12 total-box\"><h3>Total Alarms</h3><h4>{{vm.totalAlarms}} Total</h4></div></div><div class=col-md-3><div class=\"col-md-12 total-box\"><h3>Average Response</h3><h4>{{vm.averageResponse}} Minutes</h4></div></div><div class=col-md-3><div class=\"col-md-12 total-box\"><h3>Busiest Area</h3><h4>{{vm.mostAlarmsByArea}}</h4></div></div><div class=col-md-3><div class=\"col-md-12 total-box\"><h3>Busiest Alarm Type</h3><h4>{{vm.mostAlarmsByType}}</h4></div></div></div>");
$templateCache.put("app/report-site-overview/report-site-overview.html","<div class=pull-right><span ng-if=vm.loading><i class=\"fa fa-spin fa-spinner\"></i></span> <span style=\"cursor: pointer; padding: 5px 10px; border: 1px solid #ccc\"><i class=\"fa fa-calendar\"></i> <input ng-change=vm.loadEvents() type=daterange readonly datepicker-options=vm.datepickerOptions ng-model=vm.date style=\"cursor: pointer; padding: 5px 10px; border: 0px solid #ccc; width:195px\"><b class=caret style=\"margin-left: -10px\"></b></span></div><div class=pull-right style=\"padding-right: 5px\"><button type=button class=btn ng-click=vm.clearFilers() ng-if=\"vm.filters.event.length || vm.filters.name.length || vm.filters.location.length || vm.filters.area.length\">Clear Filters</button></div><!-- Insights --><!-- Hide Insights if no results --><div class=box><div class=box-title><h3><i class=fa ng-class=\"{ \'fa-lightbulb-o\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=vm.initalLoadComplete>Insights</span><span ng-if=!vm.initalLoadComplete>Loading...</span></h3></div><div class=\"box-content nopadding\"><div class=col-md-3><h5>Alarms By Site</h5><canvas id=doughnut class=\"chart chart-doughnut\" chart-click=vm.pieChartClick chart-data=vm.alarmBySiteTotals chart-labels=vm.alarmBySiteKeys chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas></div><div class=col-md-6><h5>Alarms By Hour</h5><canvas id=chart class=\"chart chart-bar\" chart-data=vm.alarmByHourTotals chart-labels=vm.alarmByHourKeys chart-dataset-override=vm.chartDatasetOverride chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas></div><div class=col-md-3><h5>Avg Response Times By Site</h5><canvas id=doughnut class=\"chart chart-doughnut\" chart-click=vm.pieChartClick chart-data=vm.responseBySiteTotals chart-labels=vm.alarmBySiteKeys chart-options=\"{legend:{display:true, position: \'bottom\'}}\"></canvas></div></div></div><!-- Weekly Information --><!-- Hide Insights if no results --><div class=box><div class=box-title><h3><i class=fa ng-class=\"{ \'fa-calendar\': vm.initalLoadComplete, \'fa-spinner\': !vm.initalLoadComplete, \'fa-spin\': !vm.initalLoadComplete}\"></i> <span ng-if=vm.initalLoadComplete>Site Statistics</span><span ng-if=!vm.initalLoadComplete>Loading...</span></h3></div><div class=\"box-content nopadding\"><div class=col-md-3><h5>Busiest Sites</h5><table class=\"table table-striped table-hover\"><thead><tr><th>Site Name</th><th>Total</th></tr></thead><tbody><tr ng-repeat=\"total in vm.sitesByAlarms | orderBy:\'-total_alarms\' | limitTo:3\" ng-click=vm.siteClick(total.name)><td>{{total.name}}</td><td>{{total.total_alarms}}</td></tr></tbody></table></div><div class=col-md-3><h5>Quietest Sites</h5><table class=\"table table-striped table-hover\"><thead><tr><th>Site Name</th><th>Total</th></tr></thead><tbody><tr ng-repeat=\"total in vm.sitesByAlarms | orderBy:\'total_alarms\' | limitTo:3\" ng-click=vm.siteClick(total.name)><td>{{total.name}}</td><td>{{total.total_alarms}}</td></tr></tbody></table></div><div class=col-md-3><h5>Slowest Responding Sites</h5><table class=\"table table-striped table-hover\"><thead><tr><th>Site Name</th><th>Response</th></tr></thead><tbody><tr ng-repeat=\"total in vm.sitesByResponse | orderBy:\'-average_response\' | limitTo:3\" ng-click=vm.siteClick(total.name)><td>{{total.name}}</td><td>{{total.average_response}} min.</td></tr></tbody></table></div><div class=col-md-3><h5>Fastest Responding Sites</h5><table class=\"table table-striped table-hover\"><thead><tr><th>Site Name</th><th>Response</th></tr></thead><tbody><tr ng-repeat=\"total in vm.sitesByResponse | orderBy:\'average_response\' | limitTo:3\" ng-click=vm.siteClick(total.name)><td>{{total.name}}</td><td>{{total.average_response}} min.</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/site/site.html","<script type=text/ng-template id=contactModal.html><div class=\"modal-content\" ng-cloak>\n		<div class=\"modal-header\">\n			<button type=\"button\" class=\"close\" ng-click=\"vm.closeModal()\">×</button>\n      <button type=\"button\" class=\"btn btn-small pull-right\" style=\"margin-right:20px\" ng-click=\"vm.editContact()\" ng-if=\"!vm.contactEdit\">Edit</button>\n      <button type=\"button\" class=\"btn btn-small pull-right\" style=\"margin-right:10px\" ng-click=\"vm.removeContact(vm.selectedContact)\" ng-if=\"vm.selectedContact.id\">Delete</button>\n      <button type=\"button\" class=\"btn btn-small pull-right\" style=\"margin-right:20px\" ng-click=\"vm.saveContact(vm.selectedContact)\" ng-if=\"vm.contactEdit\">Save</button>\n			<h4 class=\"modal-title\">Site Contact</h4>\n		</div>\n		<!-- /.modal-header -->\n		<div class=\"modal-body\" ng-if=\"!vm.contactEdit\">\n      <h3>{{vm.selectedContact.name}}</h3>\n      <h4>{{vm.selectedContact.position}}</h4>\n      <p>Cell Phone: {{vm.prettyNull(vm.selectedContact.cell_phone)}}</p>\n      <p>Office Phone: {{vm.prettyNull(vm.selectedContact.office_phone)}}</p>\n      <p>Email Address: {{vm.prettyNull(vm.selectedContact.email)}}</p>\n		</div>\n    <div class=\"modal-body\" ng-if=\"vm.contactEdit\">\n      <div class=\"form-group\">\n        <input type=\"text\" placeholder=\"Name\" class=\"form-control\" ng-model=\"vm.selectedContact.name\">\n      </div>\n      <div class=\"form-group\">\n        <input type=\"text\" placeholder=\"Position\" class=\"form-control\" ng-model=\"vm.selectedContact.position\">\n      </div>\n      <div class=\"form-group\">\n        <input type=\"text\" placeholder=\"Cell Phone\" class=\"form-control\" ng-model=\"vm.selectedContact.cell_phone\">\n      </div>\n      <div class=\"form-group\">\n        <input type=\"text\" placeholder=\"Office Phone\" class=\"form-control\" ng-model=\"vm.selectedContact.office_phone\">\n      </div>\n      <div class=\"form-group\">\n        <input type=\"text\" placeholder=\"Email\" class=\"form-control\" ng-model=\"vm.selectedContact.email\">\n      </div>\n    </div>\n	</div></script><div class=row><div class=col-sm-12><h3>Sites <span class=pull-right><button class=btn ng-click=vm.getSites()>Cancel</button> <button class=\"btn btn-success\" ladda=vm.ladda data-spinner-size=20 ng-disabled=!vm.sitesValid() ng-click=vm.saveSites()>Save</button></span></h3></div></div><div class=row><div class=col-sm-5><div class=box><div class=box-title><h3><i class=\"fa fa-home\"></i>Site List</h3></div><div class=box-content><div class=form-group><div class=input-group><input type=text ng-model=vm.searchFilter placeholder=Search class=form-control><div class=input-group-btn><button class=btn type=button ng-click=vm.clearSearch()><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Site Name</th></tr></thead><tbody><tr dir-paginate=\"site in (vm.filteredList = (vm.sites | filter:vm.searchFilter))  | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedSite == site, \'danger\':!vm.siteValid(site)}\" ng-if=!site.deleted ng-click=vm.selectSite(site)><td>{{site.name}}</td></tr></tbody></table><div class=center-pagination><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=col-sm-7><div class=box><div class=box-title><h3><i class=\"fa fa-pencil-square-o\"></i> Site Editor</h3></div><div class=box-content><span ng-hide=vm.selectedSite>No Site Selected</span><table class=\"table table-hover\" ng-if=vm.selectedSite><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Site Name</td><td><input type=text ng-disabled=true class=form-control ng-model=vm.selectedSite.name></td></tr><tr><td>Address</td><td><input type=text class=form-control ng-model=vm.selectedSite.address></td></tr><tr><td>City</td><td><input type=text class=form-control ng-model=vm.selectedSite.city></td></tr><tr><td>State</td><td><input type=text class=form-control ng-model=vm.selectedSite.state></td></tr><tr><td>Zip</td><td><input type=text class=form-control ng-model=vm.selectedSite.zip></td></tr><td>Site Groups</td><td><ui-select name=output multiple ng-model=vm.selectedSite.site_group style=\"width: 100%\"><ui-select-match ui-lock-choice=\"$item.id == 1\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"staff.id as staff in vm.siteGroups | filter:$select.search\">{{staff.name}}</ui-select-choices></ui-select></td></tbody></table></div></div><!-- Contacts --><div class=box ng-if=vm.selectedSite><div class=box-title><h3><i class=\"fa fa-pencil-square-o\"></i> Site Contacts</h3><div class=actions><a class=\"btn btn-mini\" ng-click=vm.addContact()><i class=\"fa fa-plus\"></i></a></div></div><div class=box-content><span ng-hide=vm.selectedSite>No Site Selected</span><table class=\"table table-hover\" ng-if=vm.selectedSite><thead><tr><th>Name</th><th>Position</th></tr></thead><tbody><tr ng-repeat=\"contact in vm.selectedSite.renderedContacts\" ng-click=vm.openModal(contact)><td>{{contact.name}}</td><td>{{contact.position}}</td></tr><tr ng-if=!vm.selectedSite.renderedContacts.length><td colspan=2>No Contacts Found</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/site-group/site-group.html","<div class=row><div class=col-sm-12><h3>Site Groups <span class=pull-right><button class=btn ng-click=vm.getGroups()>Cancel</button> <button class=\"btn btn-success\" ladda=vm.ladda data-spinner-size=20 ng-disabled=!vm.groupsValid() ng-click=vm.saveGroups()>Save</button></span></h3></div></div><div class=row><div class=col-sm-5><div class=box><div class=box-title><h3><i class=\"fa fa-home\"></i>Group List</h3><div class=actions><a class=\"btn btn-mini\" ng-click=vm.addGroup()><i class=\"fa fa-plus\"></i></a></div></div><div class=box-content><div class=form-group><div class=input-group><input type=text ng-model=vm.searchFilter placeholder=Search class=form-control><div class=input-group-btn><button class=btn type=button ng-click=vm.clearSearch()><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Group Name</th></tr></thead><tbody><tr dir-paginate=\"group in (vm.filteredList = (vm.groups | filter:vm.searchFilter))  | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedGroup == group, \'danger\':!vm.groupValid(group)}\" ng-if=!group.deleted ng-click=vm.loadGroup(group)><td><i class=\"fa fa-minus-circle\" ng-class=\"group.id == 1 ? \'text-muted\' : \'text-danger\'\" ng-click=\"vm.removeGroup($index, group)\"></i> {{group.name}}</td></tr></tbody></table><div class=center-pagination><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=col-sm-7><div class=box><div class=box-title><h3><i class=\"fa fa-pencil-square-o\"></i> Group Editor</h3></div><div class=box-content><span ng-hide=vm.selectedGroup>No Group Selected</span><table class=\"table table-hover\" ng-if=vm.selectedGroup><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Group Name</td><td><input ng-disabled=\"vm.selectedGroup.id == 1\" type=text class=form-control ng-model=vm.selectedGroup.name></td></tr></tbody></table></div></div><div class=box><div class=box-title><h3><i class=\"fa fa-pencil-square-o\"></i> Sites in Group</h3></div><div class=box-content><span ng-hide=vm.selectedGroup>No Group Selected</span><table class=\"table table-hover\" ng-if=vm.selectedGroup><thead><tr><th>Site Name</th><th>Address</th></tr></thead><tbody><tr ng-repeat=\"site in vm.selectedGroup.renderedSites\"><td>{{site.name}}</td><td>{{site.address}} {{site.city}}, {{site.state}} {{site.zip}}</td></tr><tr></tr><tr ng-if=!vm.selectedGroup.renderedSites.length><td colspan=2>No sites found</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/staff/staff.html","<div class=row><div class=col-sm-12><h3>Staff Management <span class=pull-right><button class=btn ng-click=vm.getStaffs()>Cancel</button> <button class=\"btn btn-success\" ladda=vm.ladda data-spinner-size=20 ng-disabled=!vm.staffsValid() ng-click=vm.saveStaffs()>Save</button></span></h3></div></div><div class=row><div class=col-sm-5><div class=box><div class=box-title><h3><i class=\"fa fa-home\"></i>Staff List</h3><div class=actions><a class=\"btn btn-mini\" ng-click=vm.addStaff()><i class=\"fa fa-plus\"></i></a></div></div><div class=box-content><div class=form-group><div class=input-group><input type=text ng-model=vm.searchFilter placeholder=Search class=form-control><div class=input-group-btn><button class=btn type=button ng-click=vm.clearSearch()><i class=\"fa fa-times text-muted\"></i></button></div></div></div><table class=\"table table-hover\"><thead><tr><th>Staff Name</th></tr></thead><tbody><tr dir-paginate=\"staff in (vm.filteredList = (vm.staffs | filter:vm.searchFilter))  | itemsPerPage:15\" ng-class=\"{\'active\': vm.selectedStaff == staff, \'danger\':!vm.staffValid(staff)}\" ng-if=!staff.deleted ng-click=\"vm.selectedStaff = staff\" ng-keydown=\"vm.keypress($event, vm.filteredList[vm.filteredList.indexOf(vm.selectedStaff) - 1], vm.filteredList[vm.filteredList.indexOf(vm.selectedStaff) + 1])\"><td><i class=\"fa fa-minus-circle text-danger\" ng-click=\"vm.removeStaff($index, staff)\"></i> {{staff.first_name}} {{staff.last_name}}</td></tr></tbody></table><div class=center-pagination><dir-pagination-controls></dir-pagination-controls></div></div></div></div><div class=col-sm-7><div class=box><div class=box-title><h3><i class=\"fa fa-pencil-square-o\"></i> Staff Editor</h3></div><div class=box-content><span ng-hide=vm.selectedStaff>No Staff Selected</span><form angular-validator name=vm.form><table class=\"table table-hover\" ng-if=vm.selectedStaff><thead><tr><th>Property</th><th>Value</th></tr></thead><tbody><tr><td>Dashboard and Door Access</td><td><select class=form-control ng-model=vm.selectedStaff.staff_type ng-options=\"item.id as item.name for item in vm.staffTypes\" ng-change=vm.staffAccessChange()></select></td></tr><tr><td>First Name</td><td><input type=text class=form-control ng-model=vm.selectedStaff.first_name></td></tr><tr><td>Last Name</td><td><input type=text class=form-control ng-model=vm.selectedStaff.last_name></td></tr><tr ng-if=\"vm.selectedStaff.staff_type != 2\"><td>Email Address</td><td><input type=text class=form-control ng-model=vm.selectedStaff.email></td></tr><tr ng-if=\"vm.selectedStaff.staff_type != 2\"><td>Username</td><td><input type=text class=form-control ng-model=vm.selectedStaff.user_name></td></tr><tr ng-if=\"vm.selectedStaff.staff_type != 2\"><td>Password</td><td><input ng-if=vm.selectedStaff.id type=password class=form-control ng-model=vm.selectedStaff.password placeholder=\"Enter a Password to Change\"><input ng-if=!vm.selectedStaff.id type=password class=form-control ng-model=vm.selectedStaff.password></td></tr><tr ng-if=\"vm.selectedStaff.staff_type != 1\"><td>Keycard Code</td><td><input type=number ignore-mouse-number name=keycard class=form-control ng-model=vm.selectedStaff.keycard validate-on=dirty validator=\"vm.validateKeycard(vm.selectedStaff.keycard, vm.selectedStaff)\" invalid-message=vm.validateKeycardMsg(vm.selectedStaff.keycard)></td></tr><tr ng-if=\"vm.selectedStaff.staff_type != 1\"><td>Keypad Code</td><td><input type=number ignore-mouse-number name=keypad class=form-control ng-model=vm.selectedStaff.keypad validate-on=dirty validator=\"vm.validateKeypad(vm.selectedStaff.keypad, vm.selectedStaff)\" invalid-message=vm.validateKeypadMsg(vm.selectedStaff.keypad)></td></tr><tr><td>Site Groups</td><td><ui-select name=output multiple ng-model=vm.selectedStaff.site_group style=\"width: 100%\"><ui-select-match>{{$item.name}}</ui-select-match><ui-select-choices repeat=\"group.id as group in vm.siteGroups | filter:$select.search\">{{group.name}}</ui-select-choices></ui-select></td></tr></tbody></table></form></div></div></div></div>");
$templateCache.put("app/components/directiveNavbar/navbar.html","<div id=navigation><div class=container-fluid><a href=# class=\"toggle-mobile hidden-md hidden-lg hidden-sm\" ng-init=\"navCollapsed = true\" ng-click=\"navCollapsed = !navCollapsed\"><i class=\"fa fa-bars\"></i> </a><a href=/ id=brand>DASHBOARD</a><!-- Left Main Menu --><ul class=\"main-nav hidden-xs\"><li uib-dropdown ng-repeat=\"topNav in vm.navItems.leftNavigationItems\"><!-- Conditionally apply the dropdown-toggle directive if subnav presented --> <a ng-if=topNav.subNav uib-dropdown-toggle href=\"{{ topNav.link }}\"><span>{{ topNav.name }}</span> <span ng-if=topNav.subNav class=caret></span> </a><a ng-if=!topNav.subNav href=\"{{ topNav.link }}\"><span>{{ topNav.name }}</span> <span ng-if=topNav.subNav class=caret></span></a><ul ng-if=topNav.subNav uib-dropdown-menu ng-if=topNav.subNav class=dropdown-menu><li ng-repeat=\"item in topNav.subNav\" ng-class=\"{\'dropdown-submenu\': item.flyout}\"><a ng-href=\"{{ item.link }}\">{{item.name}}</a><ul ng-if=item.flyout class=dropdown-menu><li ng-repeat=\"flyoutItem in item.flyout\"><a ng-href=\"{{ flyoutItem.link }}\">{{ flyoutItem.name }}</a></li></ul></li></ul></li></ul><!-- End Left Main Menu --><!-- Right User Menu --><div class=user><ul class=icon-nav><li uib-dropdown=topNav.subNav on-toggle=toggled(open) ng-repeat=\"topNav in vm.navItems.rightNavigationItems\"><a uib-dropdown-toggle=topNav.subNav ng-href=\"{{ topNav.link }}\"><i ng-if=topNav.icon ng-class=topNav.icon></i> <span ng-if=topNav.name>{{ topNav.name }}</span> <span ng-if=topNav.subNav class=caret></span></a><ul ng-if=topNav.subNav uib-dropdown-menu class=\"dropdown-menu pull-right theme-settings\"><li ng-repeat=\"item in topNav.subNav\"><a ng-href={{item.link}} ng-click=item.function()>{{item.name}}</a></li></ul></li></ul></div></div><!-- End Right User Menu --><!-- Mobile Navigation --><div class=\"hidden-md hidden-lg hidden-sm\"><div class=\"collapse navbar-collapse\" ng-class=\"!navCollapsed && \'in\'\"><ul class=\"mobile-nav open\"><li uib-dropdown ng-repeat=\"topNav in vm.navItems.leftNavigationItems\"><!-- Conditionally apply the dropdown-toggle directive if subnav presented --> <a ng-if=topNav.subNav uib-dropdown-toggle href=\"{{ topNav.link }}\" ng-click=\"vm.openMobileNav = topNav.subNav\"><span>{{ topNav.name }}</span> <span ng-if=topNav.subNav class=caret></span> </a><a ng-if=!topNav.subNav href=\"{{ topNav.link }}\"><span>{{ topNav.name }}</span> <span ng-if=topNav.subNav class=caret></span></a><ul ng-if=topNav.subNav ng-if=topNav.subNav ng-class=\"{\'open\': vm.openMobileNav == topNav.subNav}\"><li ng-repeat=\"item in topNav.subNav\"><a ng-href=\"{{ item.link }}\">{{item.name}}</a><ul ng-if=item.flyout><li ng-repeat=\"flyoutItem in item.flyout\"><a ng-href=\"{{ flyoutItem.link }}\">{{ flyoutItem.name }}</a></li></ul></li></ul></li></ul><!-- End Left Main Menu --></div></div></div>");}]);